module.exports = function () {
    return function (deliverySaverPlan = {}) {
        if (deliverySaverPlan.BillingFrequencyDays === 0) {
            switch (deliverySaverPlan.BillingFrequencyMonths) {
                case 1: return 'Monthly subscription';
                case 12: return 'Annual subscription';
            }
        } else if (deliverySaverPlan.BillingFrequencyMonths === 0) {
            switch (deliverySaverPlan.BillingFrequencyDays) {
                case 1: return 'Daily subscription';
                case 7: return 'Weekly subscription';
            }
        }
        return deliverySaverPlan.Name;
    };
};



// WEBPACK FOOTER //
// ./src/deliverysaver/delivery-saver-short-name.filter.js